import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-360f0454"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "baged-filter m-r-32" }

import { ref, computed, watch } from "vue";

import BreadCrumbs from "@/shared/menu/BreadCrumbs.vue";
import SearchInput from "@/shared/forms/SearchInput.vue";
import Button from "primevue/button";
import TopPanel from "@/widgets/sidebars/TopPanel.vue";
import Badge from "primevue/badge";

interface BreadCrumbItem {
  label: string;
  archive: string;
  route?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TopSettingsPanel',
  props: {
    isFilterEnabled: { type: Boolean },
    isFilterSetted: { type: Boolean },
    searchPlaceholder: {}
  },
  emits: ["setCommonFilter", "toggleFilter"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

const searchField = ref(null);
const debounceTimeout = ref(0);

const sendItemRequest = () => {
  emit("setCommonFilter", searchField.value);
};

watch(
  () => searchField.value,
  () => {
    if (debounceTimeout.value) clearTimeout(debounceTimeout.value);
    debounceTimeout.value = setTimeout(sendItemRequest, 400);
  },
  { immediate: true }
);

const filteredItems = ref([{ label: "Настройки", archive: "both" }]);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TopPanel, null, {
    default: _withCtx(() => [
      _createVNode(BreadCrumbs, {
        items: filteredItems.value,
        class: "bread-left"
      }, null, 8, ["items"]),
      _createVNode(SearchInput, {
        placeholder: _ctx.searchPlaceholder,
        class: "search-input",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (searchField.value = $event)),
        modelValue: searchField.value
      }, null, 8, ["placeholder", "modelValue"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(Button), {
          icon: "pi pi-filter-fill",
          id: "filter-button",
          severity: "secondary",
          "aria-label": "Bookmark",
          class: _normalizeClass(["m-l-12 f-s-0 toggled", [_ctx.isFilterEnabled ? 'filter-enabled' : '']]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('toggleFilter')))
        }, null, 8, ["class"]),
        (_ctx.isFilterSetted)
          ? (_openBlock(), _createBlock(_unref(Badge), {
              key: 0,
              class: "bage"
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})